module.exports = __webpack_public_path__ + "img/brand_77.e9122d57.png";